import React, { useState } from 'react';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function DPAModal({ isOpen, onAccept }) {
    const { user } = useAuth();
    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    const handleAccept = async () => {
        setLoading(true);
        try {
            await api.post('/op/accept-dpa');

            // Update local user state to reflect acceptance
            const updatedUser = { ...user, acceptatDPA: true };
            localStorage.setItem('user', JSON.stringify(updatedUser));

            // Call parent handler to close modal/refresh state
            if (onAccept) onAccept(updatedUser);

            // Force reload to ensure context is updated or handle via context update
            window.location.reload();

        } catch (error) {
            console.error('Accept DPA error:', error);
            alert('Eroare la acceptarea DPA. Reîncearcă.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[100] p-4">
            <div className="bg-white dark:bg-slate-800 rounded-lg shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col border border-gray-200 dark:border-slate-700">
                {/* Header */}
                <div className="p-6 border-b bg-gray-50 rounded-t-lg">
                    <h2 className="text-2xl font-bold text-gray-900 border-l-4 border-blue-600 pl-4">
                        Acord de Prelucrare a Datelor (DPA)
                    </h2>
                    <p className="mt-2 text-gray-600 dark:text-gray-400 pl-4">
                        Pentru a continua utilizarea platformei, este necesar să citești și să accepți termenii de prelucrare a datelor.
                    </p>
                </div>

                {/* Scrollable Content */}
                <div className="flex-1 overflow-y-auto p-8 prose prose-invert max-w-none text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-slate-900">
                    <div className="bg-white dark:bg-slate-800 p-8 rounded border border-gray-200 dark:border-slate-700 shadow-sm">
                        <h3 className="text-lg font-bold mb-4">ACORD PRIVIND PRELUCRAREA DATELOR CU CARACTER PERSONAL</h3>

                        <p className="mb-4"><strong>1. Părțile Acordului</strong></p>
                        <p className="mb-4">
                            Prezentul acord se încheie între <strong>Roasig.ro</strong> (împuternicit) și Dvs. (Operator de date),
                            în vederea reglementării prelucrării datelor cu caracter personal colectate prin intermediul platformei.
                        </p>

                        <p className="mb-4"><strong>2. Obiectul Prelucrării</strong></p>
                        <p className="mb-4">
                            Platforma colectează și stochează datele lead-urilor (Nume, Telefon, Email, etc.) în numele Operatorului,
                            în scopul gestionării solicitărilor de oferte.
                        </p>

                        <p className="mb-4"><strong>3. Obligațiile Părților</strong></p>
                        <ul className="list-disc ml-5 mb-4">
                            <li>Operatorul garantează că are temei legal pentru colectarea datelor.</li>
                            <li>Împuternicitul (Platforma) se obligă să asigure securitatea tehnică a datelor.</li>
                            <li>Datele sunt stocate securizat și nu sunt partajate cu terți neautorizați.</li>
                        </ul>

                        <p className="mb-4"><strong>4. Durata și Ștergerea</strong></p>
                        <p className="mb-4">
                            Datele sunt păstrate conform politicii de retenție (implicit 45 de zile), după care sunt șterse automat și ireversibil.
                        </p>

                        <p className="mb-4"><strong>5. Drepturile Persoanelor Vizate</strong></p>
                        <p className="mb-4">
                            Platforma oferă mecanisme pentru exercitarea drepturilor persoanelor vizate (ștergere, acces, rectificare).
                        </p>

                        <div className="mt-8 p-4 bg-yellow-50 border border-yellow-200 rounded text-sm">
                            * Prin apăsarea butonului "Accept și Continui", confirmați că ați citit, înțeles și sunteți de acord cu termenii acestui DPA.
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="p-6 border-t bg-gray-50 rounded-b-lg flex justify-end items-center gap-4">
                    <button
                        onClick={() => {
                            // Logout if they decline
                            localStorage.removeItem('token');
                            localStorage.removeItem('user');
                            window.location.href = '/login';
                        }}
                        className="px-6 py-3 text-gray-600 dark:text-gray-400 font-medium hover:text-red-600 transition-colors"
                    >
                        Refuz (Ieșire)
                    </button>
                    <button
                        onClick={handleAccept}
                        disabled={loading}
                        className="px-8 py-3 bg-blue-600 text-white font-bold rounded-lg shadow hover:bg-blue-700 transform transition hover:-translate-y-0.5"
                    >
                        {loading ? 'Se procesează...' : 'Am citit și Accept DPA'}
                    </button>
                </div>
            </div>
        </div>
    );
}
